import { OutboundTripDetailNotesDto } from 'dtos/outboundTrips'
import * as yup from 'yup'

export const OutboundTripDetailNotesDtoValidator = yup.object<OutboundTripDetailNotesDto>({
  internalNotes: yup.string().max(2000, 'Internal Notes cannot be more than 2,000 characters.').nullable(),
  externalNotes: yup.string().max(2000, 'Outbound Bill Of Lading Notes cannot be more than 2,000 characters.').nullable()
})
